import { render, staticRenderFns } from "./fleg-comp-isr-pago-inmenzaciones-retiro.vue?vue&type=template&id=44a5ac49&lang=html&"
import script from "./fleg-comp-isr-pago-inmenzaciones-retiro.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-isr-pago-inmenzaciones-retiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports